import React from "react";
import { FaUser, FaMapMarkerAlt, FaRupeeSign, FaHome, FaVectorSquare } from "react-icons/fa";

const PropertyCard = () => {
  const properties = [
    {
      id: 1,
      image: "/apartment1.jpg",
      name: "Modern 2BHK Apartment",
      owner: "John Doe",
      price: 5500000,
      size: 1200,
      type: "2BHK",
      location: "Mumbai",
    },
    {
      id: 2,
      image: "/apartment2.jpg",
      name: "Spacious Studio",
      owner: "Jane Smith",
      price: 3500000,
      size: 600,
      type: "Studio",
      location: "Pune",
    },
    {
      id: 3,
      image: "/apartment3.jpg",
      name: "Luxury 3BHK Condo",
      owner: "Alex Johnson",
      price: 8500000,
      size: 2000,
      type: "3BHK",
      location: "Bangalore",
    },
  ];

  return (
    <div className="p-6">
      <div className="flex flex-wrap gap-6 justify-center">
        {properties.map((property) => (
          <div
            key={property.id}
            className="relative bg-white shadow-md rounded-lg w-80 p-6 border-l-4 hover:shadow-xl hover:border-blue-600 transition duration-300 ease-in-out"
          >
            <div
              className="absolute top-0 left-0 w-full h-2 rounded-t-lg"
              style={{ backgroundColor: "#36A2EB" }}
            ></div>

            {/* Property Image */}
            <div className="rounded-lg overflow-hidden mb-4">
              <img
                src={property.image}
                alt={property.name}
                className="w-full h-52 object-cover"
              />
            </div>

            {/* Property Details */}
            <h2 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
              <FaHome className="text-primaryOrange mr-2" /> {property.name}
            </h2>

            <p className="text-gray-500 text-sm italic mb-4 flex items-center">
              <FaUser className="mr-2 text-gray-400" /> Owned by: {property.owner}
            </p>

            {/* Icon Cards for Details */}
            <div className="flex flex-col justify-between items-start mb-4 gap-3">
                <div className="flex gap-3">
                    <div className="flex items-center justify-center bg-blue-100 text-blue-600 p-2 rounded-lg shadow-md gap-0">
                    <FaRupeeSign size={12} />
                    <span className="text-sm font-semibold">
                    {property.price.toLocaleString()}
                    </span>
                </div>
                <div className="flex justify-center items-center bg-green-100 text-green-600 p-2 rounded-lg shadow-md gap-1">
                    <FaVectorSquare size={12} />
                    <span className="text-sm font-semibold">
                    {property.size} sq.ft
                    </span>
                </div>
                </div>
              
              <div className="flex justify-center items-center bg-orange-100 text-orange-600 p-2 rounded-lg shadow-md gap-1">
                <FaMapMarkerAlt size={12} />
                <span className="text-sm font-semibold">{property.location}</span>
              </div>
            </div>

            {/* Buttons */}
            {/* <div className="flex justify-between items-center mt-4">
              <button className="bg-blue-100 text-blue-600 text-sm px-4 py-2 rounded-lg font-medium hover:bg-blue-600 hover:text-white transition">
                Offer
              </button>
              <button className="bg-green-100 text-green-600 text-sm px-4 py-2 rounded-lg font-medium hover:bg-green-600 hover:text-white transition">
                Deal
              </button>
            </div> */}

            <div className="mt-6 border-t pt-4 text-sm italic text-gray-500">
              {/* Explore more about the property by clicking the buttons below. */}
            </div>

            <div className="flex gap-4 mt-4">
              <button className="flex-1 bg-primaryOrange text-white text-sm font-semibold py-2 px-4 rounded-lg hover:bg-orange-600 transition">
                View Details
              </button>
              <button className="flex-1 bg-gray-100 text-gray-700 text-sm font-semibold py-2 px-4 rounded-lg hover:bg-gray-800 hover:text-white transition">
                Instant Callback
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyCard;
